import { render, staticRenderFns } from "./CorporateDetails.vue?vue&type=template&id=0317cef5"
import script from "./CorporateDetails.vue?vue&type=script&lang=js"
export * from "./CorporateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports